import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  FindAllIndustriesQueryQuery,
  Industry
} from "../../../../schemaTypes";

export const findAllIndustriesQuery = gql`
  query FindAllIndustriesQuery {
    findAllIndustries {
      id
      name
      createdAt
      updatedAt
      isArchive
      createdBy {
        id
        admin{
          firstname
          lastname
          email
          level
        }
      }
    }
  }
`;

export const newIndustrySubscription = gql`
  subscription NewIndustrySubscription {
    newIndustry {
      id
      name
      createdAt
      updatedAt
      createdBy {
        id
        admin{
            firstname
            lastname
            email
        }
      }
    }
  }
`;

type NewIndustrySubscriptionResult = {
  newIndustry: Industry;
};

export function useFindAllIndustries() {
  const { data, loading, subscribeToMore } = useQuery<
    FindAllIndustriesQueryQuery
  >(findAllIndustriesQuery);

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newIndustrySubscription,
      updateQuery: (prev, { subscriptionData }: { subscriptionData: { data?: NewIndustrySubscriptionResult } }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findAllIndustries: [
            ...prev.findAllIndustries,
            subscriptionData.data.newIndustry
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    industries: data?.findAllIndustries ?? [],
    loading
  };
}
